import { useMutation, useQueryClient } from "@tanstack/react-query";
import { keyMaker } from "../../Entity/hooks/useAdvisorClients";
import uploadBulkAccountsV2 from "../requests/uploadBulkAccountsV2";
export default function useUploadBulkAccountsV2(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (input) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return uploadBulkAccountsV2(input.bulkAccountsDocument, input.onboardingOptions, config);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: keyMaker(),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useUploadBulkAccountsV2.js.map